import React, { useState, useRef } from 'react'
import { Table, Button, Space } from 'antd'
import { useLocalization } from '@contexts/LocalizationContext'
import { ReloadOutlined } from '@ant-design/icons'
import Fetch from '@components/CRUD/Fetch'
import ListOperation from '@components/CRUD/ListOperation'
import PageLayout from '@layouts/PageLayout'
import { client } from '@utils/client'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'order',
      key: 'order',
    },
    {
      title: 'หัวข้อ',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'ภาษา',
      dataIndex: 'language',
      key: 'language',
    },
    {
      title: 'url',
      dataIndex: 'url',
      key: 'url',
    },

    {
      title: t('promotion.list.bannerImage'),
      dataIndex: 'bannerImage',
      key: 'bannerImage',
      render: function bannerImageUrl(text) {
        return <img src={text} alt={text} width={76} />
      },
    },

    // {
    //   title: 'รายละเอียด',
    //   dataIndex: 'detail',
    // },

    {
      title: t('article.listScreen.column.checklist'),
      dataIndex: 'checklistMaps',
      key: 'checklistMaps',
      render: function checklistMaps(item) {
        return (
          <Space direction="vertical">
            {item.map((v) => {
              return (
                <Button
                  type={v.forStatus === 'notSure' ? 'default' : 'primary'}
                  danger={v.forStatus === 'failed' ? true : false}
                  key={v.articleId}
                  shape="round"
                >
                  {v.checklist.title}
                </Button>
              )
            })}
          </Space>
        )
      },
    },
    {
      width: '20%',
      title: t('article.listScreen.column.action'),
      render: function Action(record) {
        return (
          <ListOperation
            row={record}
            basePath="/blogs"
            deletePath={`/blog/${record.id}`}
            handleReload={handleReload}
          />
        )
      },
    },
  ]

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async () => {
    const result = await client
      .get('/blog', {
        params: {
          skip: (page - 1) * pageSize,
          limit: pageSize,
          order: {
            order: 1,
          },
        },
      })
      .then((res) => res.data)
    return result
  }

  return (
    <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title="บทความ (ใหม่)"
          shownBack={false}
          createPath="/blogs/create"
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('hospital.listScreen.reload')}
            </Button>,
          ]}
        >
          <Table
            rowKey="id"
            columns={columns}
            dataSource={data}
            onChange={handleChange}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          ></Table>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
